import { Injectable } from '@angular/core';
import { StorageKey } from './storage-model';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  private storage: Storage;


  constructor() {
    this.storage = sessionStorage;
  }


  syncronSave(key: StorageKey, value: any): any {
    value = JSON.stringify(value);
    return Promise.resolve(true).then(function () {
      localStorage.setItem(key, value);

    });
  }

  syncronRead(key: StorageKey): any {
    return Promise.resolve(true).then(function () {
      return JSON.parse(localStorage.getItem(key));
    });
  }

  public save(key: StorageKey, value: any): any {
    value = JSON.stringify(value);
    this.storage.setItem(key, value);
    return true;
  }

  //ORGINAL HALI
  // public save(key: StorageKey, value: any) {
  //   value = JSON.stringify(value);
  //   this.storage.setItem(key, value);
  // }

  public read(key: StorageKey): any {
    const value = this.storage.getItem(key);
    return JSON.parse(value);
  }

  public remove(key: StorageKey) {
    return this.storage.removeItem(key);
  }

  public clear() {
    this.storage.clear();
  }
}
